import {
	animation,
	trigger,
	animate,
	transition,
	state,
	style,
	query,
	group,
	animateChild,
	stagger
} from '@angular/animations';

export const backgroundAnimation = trigger('backgroundAnimation', [
	transition(':enter', [
    style({ opacity: 0 , transform: 'translate3d(0px, 0px, 10px)'}),
    animate('0.8s 0s ease-in-out', style({ opacity: 1, transform: 'translate3d(0px, 0px, 10px)' })),
  ]),
  transition(':leave', [
  	style({ opacity: 1, transform: 'translate3d(0px, 0px, 0px)' }),
    animate('0.6s 0.8s ease-in-out', style({ opacity: 0, transform: 'translate3d(0px, 0px, 0px)' }))
  ])
]);
